import type { FC } from "react";
import React from "react";
import classnames from "classnames";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { trackingService } from "@/modules/analytics";
import type { PredictionButton } from "../utils/matchPrediction.types";

import styles from "../MatchPrediction.module.scss";
import { isNonNullable } from "@/types/isNonNullable";

interface MatchPredictionButtonProps {
  isDisabled: boolean;
  handleClick: () => void;
  orientation: string;
  team: PredictionButton;
}

export const MatchPredictionButton: FC<MatchPredictionButtonProps> = (
  props,
) => {
  const { isDisabled, handleClick, orientation, team } = props;
  const onClick = () => {
    handleClick();
    if (isNonNullable(team.trackingEvents)) {
      trackingService.sendXpaTracking(
        team.trackingEvents,
        EventType.EVENT_CLICK,
      );
    }
  };

  const buttonStyle = {
    "--border-color-light": team.color,
    "--border-color-dark": team.darkModeColor,
  };

  const baseStyleButton = classnames(
    styles.buttonsElementButton,
    "title-7-bold",
    styles[`buttonsElementButton_${orientation}`],
  );

  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={baseStyleButton}
      style={buttonStyle}
    >
      {isDisabled ? `${team.percentPoints}%` : team.name}
    </button>
  );
};
